import React, { forwardRef } from 'react';
import { Icon } from 'react-feather';
import PropTypes from 'prop-types';

const FileX: Icon = forwardRef(({ color = 'currentColor', size = 24 }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.3811 1.66666V4.99999C12.3811 5.44202 12.5567 5.86594 12.8692 6.1785C13.1818 6.49106 13.6057 6.66666 14.0477 6.66666H17.3811M12.7977 10.4167L8.63106 14.5833M8.63106 10.4167L12.7977 14.5833M13.2144 1.66666H5.7144C5.27237 1.66666 4.84845 1.84225 4.53588 2.15481C4.22332 2.46737 4.04773 2.8913 4.04773 3.33332V16.6667C4.04773 17.1087 4.22332 17.5326 4.53588 17.8452C4.84845 18.1577 5.27237 18.3333 5.7144 18.3333H15.7144C16.1564 18.3333 16.5803 18.1577 16.8929 17.8452C17.2055 17.5326 17.3811 17.1087 17.3811 16.6667V5.83332L13.2144 1.66666Z"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
});

FileX.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

FileX.displayName = 'FileX';

export default FileX;
